import { render } from "./Menu-index.vue?vue&type=template&id=2b93b2e7&scoped=true"
import script from "./Menu-index.vue?vue&type=script&lang=js"
export * from "./Menu-index.vue?vue&type=script&lang=js"

import "./Menu-index.vue?vue&type=style&index=0&id=2b93b2e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b93b2e7"]])

export default __exports__